import {SDrawerOrModal, SGeneralForms} from "shj-components";
import {useEffect} from "react";
import {useSetState} from "ahooks";
import {get} from "lodash-es";
import {Form, message} from "antd";
import {getBusinessDictList} from "@/services/product.ts";
import {cancelMeasure} from "@/services/crmTool.ts";

export const CancelRoomAllocationModal = (props) => {
  const {open, onClose, record, reload} = props
  const [form] = Form.useForm()
  const [state, setState] = useSetState<any>({
    loading: false,
    reasonList: [],
  })

  useEffect(() => {
    if (open) {
      form.setFieldsValue(record)
      getOptions()
    }
    return () => {
      form.resetFields()
    }
  }, [open]);

  const getOptions = () => {
    getBusinessDictList({data: {priKey: 'measure_room_cancel'}}).then(res => {
      const list = get(res, '[0].children[0].children[0].children', [])
      setState({reasonList: handleTree(list)})
    })
  }

  const handleTree = (list) => {
    return list?.map(item => {
      item.priKey = item.object.priKey || item.id
      if(item.children){
        item.children = handleTree(item.children)
      }
      return item
    })
  }

  const onSubmit = () => {
    form.validateFields().then(values => {
      setState({loading: true})
      cancelMeasure({
        ...values,
        cancelReason: values.cancelReason[values.cancelReason.length - 1]
      }).then(res => {
        message.success(res.message || '操作成功')
        onClose()
        reload()
      }).finally(() => {
        setState({loading: false})
      })
    })
  }

  return <SDrawerOrModal
      open={open}
      mode={'modal'}
      title={'取消量房'}
      width={500}
      onCancel={onClose}
      onOk={onSubmit}
      loading={state.loading}
  >
    <SGeneralForms
        layout={'vertical'}
        formConfig={{form}}
        configs={[{
          formItem: [
            {name: 'id', hidden: true},
            {
              spanCol: 24, label: '取消原因', name: 'cancelReason',
              required: true,
              rules: [{required: true, message: '不能为空'}],
              type: 'cascader',
              comConfig: {
                options: state.reasonList,
                fieldNames: {label: 'label', value: 'priKey'},
                expandTrigger: 'hover',
              }
            },
            {spanCol: 24, label: '备注', name: 'remark',},
          ]
        }]}/>
  </SDrawerOrModal>

}